module.exports = __webpack_public_path__ + "img/profile_sp.4ab855f7.jpg";